import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';
import { RentalManagerUserInfoV2WebApiHandler_get } from '@zg-rentals/ts-rental-manager-api-client';
import { isAuthorized } from '@zg-rentals/auth-comet';
import { defineAuthProvider } from '@zg-rentals/auth-react/legacy';

import { rentalManagerHttpClient } from './httpClient';

type User = RentalManagerAuthCheckUserInfoWebApiDto;

type AuthProviderProps = {
  initialData?: User;
};

export const Auth = defineAuthProvider<AuthProviderProps, User>({
  queryOptions: ({ initialData }) => ({
    refetchInterval: 3 * 60 * 1000,
    staleTime: 30 * 1000,
    retry: false,
    initialData,
    queryFn: () => RentalManagerUserInfoV2WebApiHandler_get({}, rentalManagerHttpClient),
  }),

  isAuthorized: isAuthorized({
    mapUser: (user) => ({ ...user, isLoggedIn: user.loggedIn }),
  }),
});

export const { useAuth } = Auth;
